/**
	 * defa.collections.Invitations
	 * A Collection of Invitations.
	 * @version 1.0.0
	 * @author Benjamin Rusten
	 */

import Invitation from 'scripts/defa/invitations/model-invitation';

const Invitations = Bb.Collection.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	model : Invitation,
		
		
		
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
});

export default Invitations;
